export class Assistante {
    id:       number;
    nom:      string;
    pseudo:   string;
    password: string;
    last:     number;
}
